// extracted by mini-css-extract-plugin
export var button = "_lo-0";
export var donut = "_lo-1";
export var donutFill = "_lo-3";
export var donutTrack = "_lo-2";